import React from "react";
import PropTypes from "kf-proptypes/widgets";

import {
  KfIcon,
  KF_ICONS,
  ICON_STROKE
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./styles.css";

export function PanelCard({ children, label, onDelete, className }) {
  return (
    <div className={`${styles.panelCard} ${className}`}>
      <div className={styles.cardHeader}>
        <div className={`smallplus-600`}>{label}</div>
        <KfIcon
          icon={KF_ICONS.TRASH}
          stroke={ICON_STROKE.THIN}
          onClick={onDelete}
          className={styles.cardDeleteIcon}
        />
      </div>
      {children}
    </div>
  );
}

PanelCard.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  className: PropTypes.string
};
